module.exports = __webpack_public_path__ + "img/plus-circle.6fc0d1d1.svg";